function readConfig(obj){
   var jsonObj = JSON.parse(obj);
       //alert("读取配置文件："+jsonObj);
       //document.write("readConfig:"+jsonObj.deviceId);
//       document.getElementById("deviceId").value = "test----";//jsonObj.deviceId;
//       document.getElementById("orgId").value = jsonObj.orgId;
//       document.getElementById("orgAddress").value = jsonObj.orgAddress;
//       document.getElementById("serviceAddress").value = jsonObj.serviceAddress;
   $("#deviceId").val(jsonObj.deviceId);
   $("#orgId").val(jsonObj.orgId);
   $("#wsAddress").val(jsonObj.wsAddress);
   $("#serviceAddress").val(jsonObj.serviceAddress);
}

function openSdk(){
     window.javaObj.openSdk();
}
function openIndex(){
     window.javaObj.openIndex();
//    window.location.href = "http://192.168.3.83/client.html";
}
function openConfig(){
    window.javaObj.openConfig();

}
function openGraphConfig(){
    window.javaObj.openGraphConfig();

}
function getGraphData(){
    return window.javaObj.getGraphData();

}
function getApkVersion(){
    return window.javaObj.callAndroidGetApkVersion();
}
function getCurrentDate(){
   return (new Date()).toLocaleDateString() + " " + (new Date()).toLocaleTimeString();
}
function getSlotNo(){
//   var num_no = Math.floor(Math.random()*10+1);
   var num_no =  $("#slotNo").val();
   console.info("货道号:"+num_no);
   if(num_no=="" || num_no==undefined){
     num_no = "1";
   }
   return  num_no;
}
function jsSetData(data){
     //$("#current").text(data);
      document.getElementById("msg1").innerHTML = "android端传递数据："+data;
}

function callAndroidMethod(arg){
    //alert( "android返回信息："+ window.javaObj.jsCallAndroidMethod(arg )    );
    document.getElementById("msg2").innerHTML =  window.javaObj.jsCallAndroidMethod(arg );
}
function callAndroidDeviceMethod(arg1,arg2){
      console.info("参数1:"+arg1+",参数2："+arg2);
      window.javaObj.callAndroidDeviceMethod(arg1,arg2);
}
function callAndroidDeviceReqShipMethod(arg1,arg2,arg3,arg4){
      console.info("货道号:"+arg1+",支付方式："+arg2+"金额:"+arg3+",订单号："+arg4);
      window.javaObj.callAndroidDeviceReqShipMethod(arg1,arg2,arg3,arg4);
}
function callAndroidDeviceSplitSlotMethod(arg1){
    console.info("拆分货道,货道号:"+arg1);
    window.javaObj.callAndroidDeviceSetSplitSlotMethod(arg1);
}
function callAndroidDeviceMergeSlotMethod(arg1){
    console.info("合并货道,货道号:"+arg1);
    window.javaObj.callAndroidDeviceSetMergeSlotMethod(arg1);
}
function callAndroidDeviceSetSpringSlotMethod(arg1){
    console.info("设置弹簧货道,货道号:"+arg1);
    window.javaObj.callAndroidDeviceSetSpringSlotMethod(arg1);
}
function callAndroidDeviceSetBeltsSlotMethod(arg1){
    console.info("设置皮带货道,货道号:"+arg1);
    window.javaObj.callAndroidDeviceSetBeltsSlotMethod(arg1);
}
function writeConfig(jsonObj){
   var result = window.javaObj.writeConfig(jsonObj);
   return result;
}

function callAndroidDeviceSetDropSensorCheckMethod(b){
   var result = window.javaObj.callAndroidDeviceSetDropSensorCheckMethod(b);
   console.info("红外检测状态："+result);
   return result;
}

function reviceAndroidMsg(arg1,arg2){
    if(arg1=='querySlotStatus'){
         document.getElementById("msg3").innerHTML = arg2;
    }else if(arg1=='testSlot'){
         document.getElementById("msg3").innerHTML = arg2;
    }else if(arg1=='selectSlot'){
         document.getElementById("msg3").innerHTML = arg2;
    }else if(arg1=='reqShip'){
         document.getElementById("msg3").innerHTML = arg2;
    }else if(arg1=='splitSlot'){
         document.getElementById("msg3").innerHTML = arg2;
    }else if(arg1=='mergeSlot'){
         document.getElementById("msg3").innerHTML = arg2;
    }else if(arg1=='setBeltsSlot'){
         document.getElementById("msg3").innerHTML = arg2;
     }else if(arg1=='setSpringSlot'){
         document.getElementById("msg3").innerHTML = arg2;
    }

}

function reviceAndroidMsgDrawGraphStatus(slotNo,status){
     console.info("drawGraphStatus,slotNo:"+slotNo+",status:"+status);
     if(slotNo==='0'){
        return;
     }
     var color = '128,128,128';//灰色
     if(status=='1'){
         color = '0,176,0';//绿色
     }else if(status=='0'){
         color = '255,0,0';//红色
     }else{
         color = '128,128,128';
     }
       findNode(slotNo,color);
}
export default {
    readConfig:readConfig,
    openSdk:openSdk,
    openIndex:openIndex,
    openConfig:openConfig,
    openGraphConfig:openGraphConfig,
    getGraphData:getGraphData,
    getApkVersion:getApkVersion,
    getCurrentDate:getCurrentDate,
    getSlotNo:getSlotNo,
    jsSetData:jsSetData,
    callAndroidMethod:callAndroidMethod,
    callAndroidDeviceMethod:callAndroidDeviceMethod,
    callAndroidDeviceReqShipMethod:callAndroidDeviceReqShipMethod,
    callAndroidDeviceSplitSlotMethod:callAndroidDeviceSplitSlotMethod,
    callAndroidDeviceMergeSlotMethod:callAndroidDeviceMergeSlotMethod,
    callAndroidDeviceSetSpringSlotMethod:callAndroidDeviceSetSpringSlotMethod,
    callAndroidDeviceSetBeltsSlotMethod:callAndroidDeviceSetBeltsSlotMethod,
    writeConfig:writeConfig,
    callAndroidDeviceSetDropSensorCheckMethod:callAndroidDeviceSetDropSensorCheckMethod,
    reviceAndroidMsg:reviceAndroidMsg,
    reviceAndroidMsgDrawGraphStatus:reviceAndroidMsgDrawGraphStatus,

}


// WEBPACK FOOTER //
// ./src/assets/js/custom_es6.js